module.exports = __webpack_public_path__ + "img/index-footer-icon.b52bb93.png";